/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp5 } from './commonProp5';
import { commonProp14 } from './commonProp14';
import { commonProp4 } from './commonProp4';

export const inline_skates : {[key: string]: Array<[string, string]>} = {
    p_sex: commonProp5,
    p_size: commonProp14,
    p_brand: [
        d("Bauer"),
        d("Bladerunner"),
        d("Crivit"),
        d("Fila"),
        d("Imaginarium"),
        d("K2"),
        d("Powerslide"),
        d("Razor"),
        d("Roces"),
        d("Rollerblade"),
        d("Rulit"),
        d("Sulov"),
        d("Tempish"),
        d("Zealot"),
        ["HANDMADE", "Handmade"],
        ["OTHER_BRAND", "Jin\u00e1 zna\u010dka"],
    ],
    p_color: commonProp4,
};
